var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKdm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "360px",
    height: "360px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,-0.5 C 7.5,-0.5 15.5,-0.5 23.5,-0.5C 23.5,7.5 23.5,15.5 23.5,23.5C 15.5,23.5 7.5,23.5 -0.5,23.5C -0.5,15.5 -0.5,7.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,-0.5 C 31.5,-0.5 39.5,-0.5 47.5,-0.5C 47.5,7.5 47.5,15.5 47.5,23.5C 39.5,23.5 31.5,23.5 23.5,23.5C 23.5,15.5 23.5,7.5 23.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 47.5,-0.5 C 55.5,-0.5 63.5,-0.5 71.5,-0.5C 71.5,7.5 71.5,15.5 71.5,23.5C 63.5,23.5 55.5,23.5 47.5,23.5C 47.5,15.5 47.5,7.5 47.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 71.5,-0.5 C 79.5,-0.5 87.5,-0.5 95.5,-0.5C 95.5,7.5 95.5,15.5 95.5,23.5C 87.5,23.5 79.5,23.5 71.5,23.5C 71.5,15.5 71.5,7.5 71.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 95.5,-0.5 C 103.5,-0.5 111.5,-0.5 119.5,-0.5C 119.5,7.5 119.5,15.5 119.5,23.5C 111.5,23.5 103.5,23.5 95.5,23.5C 95.5,15.5 95.5,7.5 95.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,-0.5 C 127.5,-0.5 135.5,-0.5 143.5,-0.5C 143.5,7.5 143.5,15.5 143.5,23.5C 135.5,23.5 127.5,23.5 119.5,23.5C 119.5,15.5 119.5,7.5 119.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 143.5,-0.5 C 151.5,-0.5 159.5,-0.5 167.5,-0.5C 167.5,7.5 167.5,15.5 167.5,23.5C 159.5,23.5 151.5,23.5 143.5,23.5C 143.5,15.5 143.5,7.5 143.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,-0.5 C 175.5,-0.5 183.5,-0.5 191.5,-0.5C 191.5,7.5 191.5,15.5 191.5,23.5C 183.5,23.5 175.5,23.5 167.5,23.5C 167.5,15.5 167.5,7.5 167.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 191.5,-0.5 C 199.5,-0.5 207.5,-0.5 215.5,-0.5C 215.5,7.5 215.5,15.5 215.5,23.5C 207.5,23.5 199.5,23.5 191.5,23.5C 191.5,15.5 191.5,7.5 191.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 215.5,-0.5 C 223.5,-0.5 231.5,-0.5 239.5,-0.5C 239.5,7.5 239.5,15.5 239.5,23.5C 231.5,23.5 223.5,23.5 215.5,23.5C 215.5,15.5 215.5,7.5 215.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 239.5,-0.5 C 247.5,-0.5 255.5,-0.5 263.5,-0.5C 263.5,7.5 263.5,15.5 263.5,23.5C 255.5,23.5 247.5,23.5 239.5,23.5C 239.5,15.5 239.5,7.5 239.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,-0.5 C 271.5,-0.5 279.5,-0.5 287.5,-0.5C 287.5,7.5 287.5,15.5 287.5,23.5C 279.5,23.5 271.5,23.5 263.5,23.5C 263.5,15.5 263.5,7.5 263.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,-0.5 C 295.5,-0.5 303.5,-0.5 311.5,-0.5C 311.5,7.5 311.5,15.5 311.5,23.5C 303.5,23.5 295.5,23.5 287.5,23.5C 287.5,15.5 287.5,7.5 287.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,-0.5 C 319.5,-0.5 327.5,-0.5 335.5,-0.5C 335.5,7.5 335.5,15.5 335.5,23.5C 327.5,23.5 319.5,23.5 311.5,23.5C 311.5,15.5 311.5,7.5 311.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,-0.5 C 343.5,-0.5 351.5,-0.5 359.5,-0.5C 359.5,7.5 359.5,15.5 359.5,23.5C 351.5,23.5 343.5,23.5 335.5,23.5C 335.5,15.5 335.5,7.5 335.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,23.5 C 7.5,23.5 15.5,23.5 23.5,23.5C 23.5,31.5 23.5,39.5 23.5,47.5C 15.5,47.5 7.5,47.5 -0.5,47.5C -0.5,39.5 -0.5,31.5 -0.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 23.5,23.5 C 31.5,23.5 39.5,23.5 47.5,23.5C 47.5,31.5 47.5,39.5 47.5,47.5C 39.5,47.5 31.5,47.5 23.5,47.5C 23.5,39.5 23.5,31.5 23.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 47.5,23.5 C 55.5,23.5 63.5,23.5 71.5,23.5C 71.5,31.5 71.5,39.5 71.5,47.5C 63.5,47.5 55.5,47.5 47.5,47.5C 47.5,39.5 47.5,31.5 47.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 71.5,23.5 C 79.5,23.5 87.5,23.5 95.5,23.5C 95.5,31.5 95.5,39.5 95.5,47.5C 87.5,47.5 79.5,47.5 71.5,47.5C 71.5,39.5 71.5,31.5 71.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 95.5,23.5 C 103.5,23.5 111.5,23.5 119.5,23.5C 119.5,31.5 119.5,39.5 119.5,47.5C 111.5,47.5 103.5,47.5 95.5,47.5C 95.5,39.5 95.5,31.5 95.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 119.5,23.5 C 127.5,23.5 135.5,23.5 143.5,23.5C 143.5,31.5 143.5,39.5 143.5,47.5C 135.5,47.5 127.5,47.5 119.5,47.5C 119.5,39.5 119.5,31.5 119.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 167.5,23.5 C 175.5,23.5 183.5,23.5 191.5,23.5C 191.334,30.8409 191.5,38.1742 192,45.5C 192.717,46.0442 193.217,46.7109 193.5,47.5C 184.164,46.2108 174.831,46.2108 165.5,47.5C 165.783,46.7109 166.283,46.0442 167,45.5C 167.5,38.1742 167.666,30.8409 167.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 191.5,23.5 C 199.5,23.5 207.5,23.5 215.5,23.5C 215.5,31.5 215.5,39.5 215.5,47.5C 208.167,47.5 200.833,47.5 193.5,47.5C 193.217,46.7109 192.717,46.0442 192,45.5C 191.5,38.1742 191.334,30.8409 191.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 239.5,23.5 C 247.5,23.5 255.5,23.5 263.5,23.5C 263.5,31.5 263.5,39.5 263.5,47.5C 255.5,47.5 247.5,47.5 239.5,47.5C 239.5,39.5 239.5,31.5 239.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 263.5,23.5 C 271.5,23.5 279.5,23.5 287.5,23.5C 287.5,31.5 287.5,39.5 287.5,47.5C 279.5,47.5 271.5,47.5 263.5,47.5C 263.5,39.5 263.5,31.5 263.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 287.5,23.5 C 295.5,23.5 303.5,23.5 311.5,23.5C 311.5,31.5 311.5,39.5 311.5,47.5C 303.5,47.5 295.5,47.5 287.5,47.5C 287.5,39.5 287.5,31.5 287.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 311.5,23.5 C 319.5,23.5 327.5,23.5 335.5,23.5C 335.5,31.5 335.5,39.5 335.5,47.5C 327.5,47.5 319.5,47.5 311.5,47.5C 311.5,39.5 311.5,31.5 311.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,23.5 C 343.5,23.5 351.5,23.5 359.5,23.5C 359.5,31.5 359.5,39.5 359.5,47.5C 351.5,47.5 343.5,47.5 335.5,47.5C 335.5,39.5 335.5,31.5 335.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,47.5 C 7.5,47.5 15.5,47.5 23.5,47.5C 23.5,55.5 23.5,63.5 23.5,71.5C 15.5,71.5 7.5,71.5 -0.5,71.5C -0.5,63.5 -0.5,55.5 -0.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,47.5 C 31.5,47.5 39.5,47.5 47.5,47.5C 47.5,55.5 47.5,63.5 47.5,71.5C 39.5,71.5 31.5,71.5 23.5,71.5C 23.5,63.5 23.5,55.5 23.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 47.5,47.5 C 55.5,47.5 63.5,47.5 71.5,47.5C 71.5,55.5 71.5,63.5 71.5,71.5C 63.5,71.5 55.5,71.5 47.5,71.5C 47.5,63.5 47.5,55.5 47.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 71.5,47.5 C 79.5,47.5 87.5,47.5 95.5,47.5C 95.5,55.5 95.5,63.5 95.5,71.5C 87.5,71.5 79.5,71.5 71.5,71.5C 71.5,63.5 71.5,55.5 71.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 95.5,47.5 C 103.5,47.5 111.5,47.5 119.5,47.5C 119.5,55.5 119.5,63.5 119.5,71.5C 111.5,71.5 103.5,71.5 95.5,71.5C 95.5,63.5 95.5,55.5 95.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 143.5,23.5 C 151.5,23.5 159.5,23.5 167.5,23.5C 167.666,30.8409 167.5,38.1742 167,45.5C 166.283,46.0442 165.783,46.7109 165.5,47.5C 138.631,53.0384 121.964,69.0384 115.5,95.5C 108.833,95.5 102.167,95.5 95.5,95.5C 95.5,87.5 95.5,79.5 95.5,71.5C 103.5,71.5 111.5,71.5 119.5,71.5C 119.5,63.5 119.5,55.5 119.5,47.5C 127.5,47.5 135.5,47.5 143.5,47.5C 143.5,39.5 143.5,31.5 143.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#141414",
    d: "M 193.5,47.5 C 214.239,51.5785 229.572,62.9119 239.5,81.5C 241.166,86.1773 242.499,90.844 243.5,95.5C 244.365,103.466 244.698,111.466 244.5,119.5C 243.445,125.769 242.112,132.102 240.5,138.5C 234.73,156.449 224.396,171.283 209.5,183C 202.446,187.032 195.113,190.199 187.5,192.5C 181.5,192.5 175.5,192.5 169.5,192.5C 152.083,187.012 138.583,176.346 129,160.5C 125.341,154.317 122.174,147.983 119.5,141.5C 117.069,133.678 115.402,125.678 114.5,117.5C 114.317,110.132 114.65,102.799 115.5,95.5C 121.964,69.0384 138.631,53.0384 165.5,47.5C 174.831,46.2108 184.164,46.2108 193.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f1f1",
    d: "M 215.5,23.5 C 223.5,23.5 231.5,23.5 239.5,23.5C 239.5,31.5 239.5,39.5 239.5,47.5C 247.5,47.5 255.5,47.5 263.5,47.5C 263.5,55.5 263.5,63.5 263.5,71.5C 255.5,71.5 247.5,71.5 239.5,71.5C 239.5,74.8333 239.5,78.1667 239.5,81.5C 229.572,62.9119 214.239,51.5785 193.5,47.5C 200.833,47.5 208.167,47.5 215.5,47.5C 215.5,39.5 215.5,31.5 215.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,47.5 C 271.5,47.5 279.5,47.5 287.5,47.5C 287.5,55.5 287.5,63.5 287.5,71.5C 279.5,71.5 271.5,71.5 263.5,71.5C 263.5,63.5 263.5,55.5 263.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,47.5 C 295.5,47.5 303.5,47.5 311.5,47.5C 311.5,55.5 311.5,63.5 311.5,71.5C 303.5,71.5 295.5,71.5 287.5,71.5C 287.5,63.5 287.5,55.5 287.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,47.5 C 319.5,47.5 327.5,47.5 335.5,47.5C 335.5,55.5 335.5,63.5 335.5,71.5C 327.5,71.5 319.5,71.5 311.5,71.5C 311.5,63.5 311.5,55.5 311.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,47.5 C 343.5,47.5 351.5,47.5 359.5,47.5C 359.5,55.5 359.5,63.5 359.5,71.5C 351.5,71.5 343.5,71.5 335.5,71.5C 335.5,63.5 335.5,55.5 335.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 191.5,53.5 C 191.5,59.5 191.5,65.5 191.5,71.5C 183.5,71.5 175.5,71.5 167.5,71.5C 167.5,65.5 167.5,59.5 167.5,53.5C 175.5,52.1667 183.5,52.1667 191.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,71.5 C 7.5,71.5 15.5,71.5 23.5,71.5C 23.5,79.5 23.5,87.5 23.5,95.5C 15.5,95.5 7.5,95.5 -0.5,95.5C -0.5,87.5 -0.5,79.5 -0.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 23.5,71.5 C 31.5,71.5 39.5,71.5 47.5,71.5C 47.5,79.5 47.5,87.5 47.5,95.5C 39.5,95.5 31.5,95.5 23.5,95.5C 23.5,87.5 23.5,79.5 23.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 47.5,71.5 C 55.5,71.5 63.5,71.5 71.5,71.5C 71.5,79.5 71.5,87.5 71.5,95.5C 63.5,95.5 55.5,95.5 47.5,95.5C 47.5,87.5 47.5,79.5 47.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 71.5,71.5 C 79.5,71.5 87.5,71.5 95.5,71.5C 95.5,79.5 95.5,87.5 95.5,95.5C 87.5,95.5 79.5,95.5 71.5,95.5C 71.5,87.5 71.5,79.5 71.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e9e9",
    d: "M 167.5,53.5 C 167.5,59.5 167.5,65.5 167.5,71.5C 159.5,71.5 151.5,71.5 143.5,71.5C 143.5,79.5 143.5,87.5 143.5,95.5C 137.167,95.5 130.833,95.5 124.5,95.5C 125.014,93.4884 125.18,91.4884 125,89.5C 123.154,92.5687 122.154,95.9021 122,99.5C 121.5,106.158 121.334,112.825 121.5,119.5C 117.048,93.3654 126.048,73.1987 148.5,59C 154.521,56.0783 160.854,54.245 167.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,71.5 C 167.5,79.5 167.5,87.5 167.5,95.5C 159.5,95.5 151.5,95.5 143.5,95.5C 143.5,87.5 143.5,79.5 143.5,71.5C 151.5,71.5 159.5,71.5 167.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 167.5,71.5 C 175.5,71.5 183.5,71.5 191.5,71.5C 191.5,79.5 191.5,87.5 191.5,95.5C 183.5,95.5 175.5,95.5 167.5,95.5C 167.5,87.5 167.5,79.5 167.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 191.5,71.5 C 199.5,71.5 207.5,71.5 215.5,71.5C 215.5,79.5 215.5,87.5 215.5,95.5C 207.5,95.5 199.5,95.5 191.5,95.5C 191.5,87.5 191.5,79.5 191.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaea",
    d: "M 191.5,53.5 C 216.092,57.4277 231.425,71.4277 237.5,95.5C 230.377,95.4123 223.044,95.4123 215.5,95.5C 215.5,87.5 215.5,79.5 215.5,71.5C 207.5,71.5 199.5,71.5 191.5,71.5C 191.5,65.5 191.5,59.5 191.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 263.5,71.5 C 263.5,79.5 263.5,87.5 263.5,95.5C 257.04,94.9032 250.874,95.5698 245,97.5C 244.722,96.5842 244.222,95.9175 243.5,95.5C 242.499,90.844 241.166,86.1773 239.5,81.5C 239.5,78.1667 239.5,74.8333 239.5,71.5C 247.5,71.5 255.5,71.5 263.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 263.5,71.5 C 271.5,71.5 279.5,71.5 287.5,71.5C 287.5,79.5 287.5,87.5 287.5,95.5C 279.5,95.5 271.5,95.5 263.5,95.5C 263.5,87.5 263.5,79.5 263.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 287.5,71.5 C 295.5,71.5 303.5,71.5 311.5,71.5C 311.5,79.5 311.5,87.5 311.5,95.5C 303.5,95.5 295.5,95.5 287.5,95.5C 287.5,87.5 287.5,79.5 287.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 311.5,71.5 C 319.5,71.5 327.5,71.5 335.5,71.5C 335.5,79.5 335.5,87.5 335.5,95.5C 327.5,95.5 319.5,95.5 311.5,95.5C 311.5,87.5 311.5,79.5 311.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,71.5 C 343.5,71.5 351.5,71.5 359.5,71.5C 359.5,79.5 359.5,87.5 359.5,95.5C 351.5,95.5 343.5,95.5 335.5,95.5C 335.5,87.5 335.5,79.5 335.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 237.5,95.5 C 238.437,103.445 238.77,111.445 238.5,119.5C 230.833,119.5 223.167,119.5 215.5,119.5C 215.5,111.5 215.5,103.5 215.5,95.5C 223.044,95.4123 230.377,95.4123 237.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,95.5 C 7.5,95.5 15.5,95.5 23.5,95.5C 23.5,103.5 23.5,111.5 23.5,119.5C 15.5,119.5 7.5,119.5 -0.5,119.5C -0.5,111.5 -0.5,103.5 -0.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,95.5 C 31.5,95.5 39.5,95.5 47.5,95.5C 47.5,103.5 47.5,111.5 47.5,119.5C 39.5,119.5 31.5,119.5 23.5,119.5C 23.5,111.5 23.5,103.5 23.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 47.5,95.5 C 55.5,95.5 63.5,95.5 71.5,95.5C 71.5,103.5 71.5,111.5 71.5,119.5C 63.5,119.5 55.5,119.5 47.5,119.5C 47.5,111.5 47.5,103.5 47.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 71.5,95.5 C 79.5,95.5 87.5,95.5 95.5,95.5C 95.5,103.5 95.5,111.5 95.5,119.5C 87.5,119.5 79.5,119.5 71.5,119.5C 71.5,111.5 71.5,103.5 71.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 95.5,95.5 C 102.167,95.5 108.833,95.5 115.5,95.5C 114.65,102.799 114.317,110.132 114.5,117.5C 108.455,119.393 102.121,120.06 95.5,119.5C 95.5,111.5 95.5,103.5 95.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 143.5,95.5 C 143.5,103.5 143.5,111.5 143.5,119.5C 136.167,119.5 128.833,119.5 121.5,119.5C 121.334,112.825 121.5,106.158 122,99.5C 122.154,95.9021 123.154,92.5687 125,89.5C 125.18,91.4884 125.014,93.4884 124.5,95.5C 130.833,95.5 137.167,95.5 143.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 143.5,95.5 C 151.5,95.5 159.5,95.5 167.5,95.5C 167.5,103.5 167.5,111.5 167.5,119.5C 159.5,119.5 151.5,119.5 143.5,119.5C 143.5,111.5 143.5,103.5 143.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,95.5 C 175.5,95.5 183.5,95.5 191.5,95.5C 191.5,103.5 191.5,111.5 191.5,119.5C 183.5,119.5 175.5,119.5 167.5,119.5C 167.5,111.5 167.5,103.5 167.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 191.5,95.5 C 199.5,95.5 207.5,95.5 215.5,95.5C 215.5,103.5 215.5,111.5 215.5,119.5C 207.5,119.5 199.5,119.5 191.5,119.5C 191.5,111.5 191.5,103.5 191.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 243.5,95.5 C 244.222,95.9175 244.722,96.5842 245,97.5C 250.874,95.5698 257.04,94.9032 263.5,95.5C 263.5,103.5 263.5,111.5 263.5,119.5C 257.167,119.5 250.833,119.5 244.5,119.5C 244.698,111.466 244.365,103.466 243.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,95.5 C 271.5,95.5 279.5,95.5 287.5,95.5C 287.5,103.5 287.5,111.5 287.5,119.5C 279.5,119.5 271.5,119.5 263.5,119.5C 263.5,111.5 263.5,103.5 263.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,95.5 C 295.5,95.5 303.5,95.5 311.5,95.5C 311.5,103.5 311.5,111.5 311.5,119.5C 303.5,119.5 295.5,119.5 287.5,119.5C 287.5,111.5 287.5,103.5 287.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,95.5 C 319.5,95.5 327.5,95.5 335.5,95.5C 335.5,103.5 335.5,111.5 335.5,119.5C 327.5,119.5 319.5,119.5 311.5,119.5C 311.5,111.5 311.5,103.5 311.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,95.5 C 343.5,95.5 351.5,95.5 359.5,95.5C 359.5,103.5 359.5,111.5 359.5,119.5C 351.5,119.5 343.5,119.5 335.5,119.5C 335.5,111.5 335.5,103.5 335.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,119.5 C 7.5,119.5 15.5,119.5 23.5,119.5C 23.5,127.5 23.5,135.5 23.5,143.5C 15.5,143.5 7.5,143.5 -0.5,143.5C -0.5,135.5 -0.5,127.5 -0.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 23.5,119.5 C 31.5,119.5 39.5,119.5 47.5,119.5C 47.5,127.5 47.5,135.5 47.5,143.5C 39.5,143.5 31.5,143.5 23.5,143.5C 23.5,135.5 23.5,127.5 23.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 47.5,119.5 C 55.5,119.5 63.5,119.5 71.5,119.5C 71.5,127.5 71.5,135.5 71.5,143.5C 63.5,143.5 55.5,143.5 47.5,143.5C 47.5,135.5 47.5,127.5 47.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 71.5,119.5 C 79.5,119.5 87.5,119.5 95.5,119.5C 95.5,127.5 95.5,135.5 95.5,143.5C 87.5,143.5 79.5,143.5 71.5,143.5C 71.5,135.5 71.5,127.5 71.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 114.5,117.5 C 115.402,125.678 117.069,133.678 119.5,141.5C 111.903,143.467 103.903,144.134 95.5,143.5C 95.5,135.5 95.5,127.5 95.5,119.5C 102.121,120.06 108.455,119.393 114.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 121.5,119.5 C 128.833,119.5 136.167,119.5 143.5,119.5C 143.5,127.5 143.5,135.5 143.5,143.5C 138.167,143.5 132.833,143.5 127.5,143.5C 123.864,136.011 121.864,128.011 121.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 143.5,119.5 C 151.5,119.5 159.5,119.5 167.5,119.5C 167.5,127.5 167.5,135.5 167.5,143.5C 159.5,143.5 151.5,143.5 143.5,143.5C 143.5,135.5 143.5,127.5 143.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 167.5,119.5 C 175.5,119.5 183.5,119.5 191.5,119.5C 191.5,127.5 191.5,135.5 191.5,143.5C 183.5,143.5 175.5,143.5 167.5,143.5C 167.5,135.5 167.5,127.5 167.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 191.5,119.5 C 199.5,119.5 207.5,119.5 215.5,119.5C 215.5,127.5 215.5,135.5 215.5,143.5C 207.5,143.5 199.5,143.5 191.5,143.5C 191.5,135.5 191.5,127.5 191.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 215.5,119.5 C 223.167,119.5 230.833,119.5 238.5,119.5C 237.4,125.499 236.234,131.499 235,137.5C 233.968,139.994 232.802,142.328 231.5,144.5C 226.36,143.512 221.026,143.179 215.5,143.5C 215.5,135.5 215.5,127.5 215.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 244.5,119.5 C 250.833,119.5 257.167,119.5 263.5,119.5C 263.5,127.5 263.5,135.5 263.5,143.5C 255.493,143.666 247.493,143.5 239.5,143C 240.38,141.644 240.714,140.144 240.5,138.5C 242.112,132.102 243.445,125.769 244.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 263.5,119.5 C 271.5,119.5 279.5,119.5 287.5,119.5C 287.5,127.5 287.5,135.5 287.5,143.5C 279.5,143.5 271.5,143.5 263.5,143.5C 263.5,135.5 263.5,127.5 263.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 287.5,119.5 C 295.5,119.5 303.5,119.5 311.5,119.5C 311.5,127.5 311.5,135.5 311.5,143.5C 303.5,143.5 295.5,143.5 287.5,143.5C 287.5,135.5 287.5,127.5 287.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 311.5,119.5 C 319.5,119.5 327.5,119.5 335.5,119.5C 335.5,127.5 335.5,135.5 335.5,143.5C 327.5,143.5 319.5,143.5 311.5,143.5C 311.5,135.5 311.5,127.5 311.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,119.5 C 343.5,119.5 351.5,119.5 359.5,119.5C 359.5,127.5 359.5,135.5 359.5,143.5C 351.5,143.5 343.5,143.5 335.5,143.5C 335.5,135.5 335.5,127.5 335.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,143.5 C 7.5,143.5 15.5,143.5 23.5,143.5C 23.5,151.5 23.5,159.5 23.5,167.5C 15.5,167.5 7.5,167.5 -0.5,167.5C -0.5,159.5 -0.5,151.5 -0.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,143.5 C 31.5,143.5 39.5,143.5 47.5,143.5C 47.5,151.5 47.5,159.5 47.5,167.5C 39.5,167.5 31.5,167.5 23.5,167.5C 23.5,159.5 23.5,151.5 23.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 47.5,143.5 C 55.5,143.5 63.5,143.5 71.5,143.5C 71.5,151.5 71.5,159.5 71.5,167.5C 63.5,167.5 55.5,167.5 47.5,167.5C 47.5,159.5 47.5,151.5 47.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 71.5,143.5 C 79.5,143.5 87.5,143.5 95.5,143.5C 95.5,151.5 95.5,159.5 95.5,167.5C 87.5,167.5 79.5,167.5 71.5,167.5C 71.5,159.5 71.5,151.5 71.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 119.5,141.5 C 122.174,147.983 125.341,154.317 129,160.5C 138.583,176.346 152.083,187.012 169.5,192.5C 168.133,198.866 166.8,205.366 165.5,212C 166.416,212.278 167.082,212.778 167.5,213.5C 159.5,212.499 152.5,209.333 146.5,204C 140.175,203.5 133.842,203.334 127.5,203.5C 132.64,202.512 137.974,202.179 143.5,202.5C 143.5,198.833 143.5,195.167 143.5,191.5C 135.5,191.5 127.5,191.5 119.5,191.5C 119.5,183.5 119.5,175.5 119.5,167.5C 111.5,167.5 103.5,167.5 95.5,167.5C 95.5,159.5 95.5,151.5 95.5,143.5C 103.903,144.134 111.903,143.467 119.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeeee",
    d: "M 143.5,143.5 C 151.5,143.5 159.5,143.5 167.5,143.5C 167.5,151.5 167.5,159.5 167.5,167.5C 159.787,167.398 152.287,167.731 145,168.5C 143.533,160.337 143.033,152.004 143.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,143.5 C 175.5,143.5 183.5,143.5 191.5,143.5C 191.5,151.5 191.5,159.5 191.5,167.5C 183.5,167.5 175.5,167.5 167.5,167.5C 167.5,159.5 167.5,151.5 167.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 191.5,143.5 C 199.5,143.5 207.5,143.5 215.5,143.5C 215.5,151.5 215.5,159.5 215.5,167.5C 207.5,167.5 199.5,167.5 191.5,167.5C 191.5,159.5 191.5,151.5 191.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 240.5,138.5 C 240.714,140.144 240.38,141.644 239.5,143C 247.493,143.5 255.493,143.666 263.5,143.5C 263.5,151.5 263.5,159.5 263.5,167.5C 255.5,167.5 247.5,167.5 239.5,167.5C 239.5,175.5 239.5,183.5 239.5,191.5C 231.5,191.5 223.5,191.5 215.5,191.5C 215.5,195.167 215.5,198.833 215.5,202.5C 221.026,202.179 226.36,202.512 231.5,203.5C 225.158,203.334 218.825,203.5 212.5,204C 209.328,205.752 206.328,207.752 203.5,210C 200.223,211.143 196.89,211.977 193.5,212.5C 191.601,206.118 190.934,199.451 191.5,192.5C 190.167,192.5 188.833,192.5 187.5,192.5C 195.113,190.199 202.446,187.032 209.5,183C 224.396,171.283 234.73,156.449 240.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,143.5 C 271.5,143.5 279.5,143.5 287.5,143.5C 287.5,151.5 287.5,159.5 287.5,167.5C 279.5,167.5 271.5,167.5 263.5,167.5C 263.5,159.5 263.5,151.5 263.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,143.5 C 295.5,143.5 303.5,143.5 311.5,143.5C 311.5,151.5 311.5,159.5 311.5,167.5C 303.5,167.5 295.5,167.5 287.5,167.5C 287.5,159.5 287.5,151.5 287.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,143.5 C 319.5,143.5 327.5,143.5 335.5,143.5C 335.5,151.5 335.5,159.5 335.5,167.5C 327.5,167.5 319.5,167.5 311.5,167.5C 311.5,159.5 311.5,151.5 311.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,143.5 C 343.5,143.5 351.5,143.5 359.5,143.5C 359.5,151.5 359.5,159.5 359.5,167.5C 351.5,167.5 343.5,167.5 335.5,167.5C 335.5,159.5 335.5,151.5 335.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,167.5 C 7.5,167.5 15.5,167.5 23.5,167.5C 23.5,175.5 23.5,183.5 23.5,191.5C 15.5,191.5 7.5,191.5 -0.5,191.5C -0.5,183.5 -0.5,175.5 -0.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 23.5,167.5 C 31.5,167.5 39.5,167.5 47.5,167.5C 47.5,175.5 47.5,183.5 47.5,191.5C 39.5,191.5 31.5,191.5 23.5,191.5C 23.5,183.5 23.5,175.5 23.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 47.5,167.5 C 55.5,167.5 63.5,167.5 71.5,167.5C 71.5,175.5 71.5,183.5 71.5,191.5C 63.5,191.5 55.5,191.5 47.5,191.5C 47.5,183.5 47.5,175.5 47.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 71.5,167.5 C 79.5,167.5 87.5,167.5 95.5,167.5C 95.5,175.5 95.5,183.5 95.5,191.5C 87.5,191.5 79.5,191.5 71.5,191.5C 71.5,183.5 71.5,175.5 71.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 95.5,167.5 C 103.5,167.5 111.5,167.5 119.5,167.5C 119.5,175.5 119.5,183.5 119.5,191.5C 111.5,191.5 103.5,191.5 95.5,191.5C 95.5,183.5 95.5,175.5 95.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 127.5,143.5 C 132.833,143.5 138.167,143.5 143.5,143.5C 143.033,152.004 143.533,160.337 145,168.5C 152.287,167.731 159.787,167.398 167.5,167.5C 167.5,173.167 167.5,178.833 167.5,184.5C 156.75,181.934 147.916,176.267 141,167.5C 135.182,160.193 130.682,152.193 127.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 167.5,167.5 C 175.5,167.5 183.5,167.5 191.5,167.5C 191.5,173.167 191.5,178.833 191.5,184.5C 190.737,185.268 189.737,185.768 188.5,186C 182.167,186.667 175.833,186.667 169.5,186C 168.584,185.722 167.918,185.222 167.5,184.5C 167.5,178.833 167.5,173.167 167.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 215.5,143.5 C 221.026,143.179 226.36,143.512 231.5,144.5C 226.126,158.388 217.459,169.888 205.5,179C 201.137,181.684 196.47,183.518 191.5,184.5C 191.5,178.833 191.5,173.167 191.5,167.5C 199.5,167.5 207.5,167.5 215.5,167.5C 215.5,159.5 215.5,151.5 215.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,167.5 C 263.5,175.5 263.5,183.5 263.5,191.5C 255.5,191.5 247.5,191.5 239.5,191.5C 239.5,183.5 239.5,175.5 239.5,167.5C 247.5,167.5 255.5,167.5 263.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 263.5,167.5 C 271.5,167.5 279.5,167.5 287.5,167.5C 287.5,175.5 287.5,183.5 287.5,191.5C 279.5,191.5 271.5,191.5 263.5,191.5C 263.5,183.5 263.5,175.5 263.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 287.5,167.5 C 295.5,167.5 303.5,167.5 311.5,167.5C 311.5,175.5 311.5,183.5 311.5,191.5C 303.5,191.5 295.5,191.5 287.5,191.5C 287.5,183.5 287.5,175.5 287.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 311.5,167.5 C 319.5,167.5 327.5,167.5 335.5,167.5C 335.5,175.5 335.5,183.5 335.5,191.5C 327.5,191.5 319.5,191.5 311.5,191.5C 311.5,183.5 311.5,175.5 311.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,167.5 C 343.5,167.5 351.5,167.5 359.5,167.5C 359.5,175.5 359.5,183.5 359.5,191.5C 351.5,191.5 343.5,191.5 335.5,191.5C 335.5,183.5 335.5,175.5 335.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,191.5 C 7.5,191.5 15.5,191.5 23.5,191.5C 23.5,199.5 23.5,207.5 23.5,215.5C 15.5,215.5 7.5,215.5 -0.5,215.5C -0.5,207.5 -0.5,199.5 -0.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,191.5 C 31.5,191.5 39.5,191.5 47.5,191.5C 47.5,199.5 47.5,207.5 47.5,215.5C 39.5,215.5 31.5,215.5 23.5,215.5C 23.5,207.5 23.5,199.5 23.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 71.5,191.5 C 79.5,191.5 87.5,191.5 95.5,191.5C 95.5975,198.377 95.5975,205.044 95.5,211.5C 92.2054,213.147 88.8721,214.814 85.5,216.5C 80.8969,215.617 76.2303,215.283 71.5,215.5C 71.5,207.5 71.5,199.5 71.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebebeb",
    d: "M 95.5,191.5 C 103.5,191.5 111.5,191.5 119.5,191.5C 119.5,195.5 119.5,199.5 119.5,203.5C 120.833,203.5 122.167,203.5 123.5,203.5C 113.978,205.114 104.644,207.78 95.5,211.5C 95.5975,205.044 95.5975,198.377 95.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 119.5,191.5 C 127.5,191.5 135.5,191.5 143.5,191.5C 143.5,195.167 143.5,198.833 143.5,202.5C 137.974,202.179 132.64,202.512 127.5,203.5C 126.167,203.5 124.833,203.5 123.5,203.5C 122.167,203.5 120.833,203.5 119.5,203.5C 119.5,199.5 119.5,195.5 119.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 239.5,191.5 C 239.5,195.5 239.5,199.5 239.5,203.5C 237.833,203.5 236.167,203.5 234.5,203.5C 233.5,203.5 232.5,203.5 231.5,203.5C 226.36,202.512 221.026,202.179 215.5,202.5C 215.5,198.833 215.5,195.167 215.5,191.5C 223.5,191.5 231.5,191.5 239.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e8e8",
    d: "M 239.5,191.5 C 247.5,191.5 255.5,191.5 263.5,191.5C 263.192,197.425 263.525,203.259 264.5,209C 263.244,209.417 262.577,210.25 262.5,211.5C 253.202,208.085 243.869,205.418 234.5,203.5C 236.167,203.5 237.833,203.5 239.5,203.5C 239.5,199.5 239.5,195.5 239.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,191.5 C 295.5,191.5 303.5,191.5 311.5,191.5C 311.5,199.5 311.5,207.5 311.5,215.5C 303.5,215.5 295.5,215.5 287.5,215.5C 287.5,207.5 287.5,199.5 287.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,191.5 C 319.5,191.5 327.5,191.5 335.5,191.5C 335.5,199.5 335.5,207.5 335.5,215.5C 327.5,215.5 319.5,215.5 311.5,215.5C 311.5,207.5 311.5,199.5 311.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,191.5 C 343.5,191.5 351.5,191.5 359.5,191.5C 359.5,199.5 359.5,207.5 359.5,215.5C 351.5,215.5 343.5,215.5 335.5,215.5C 335.5,207.5 335.5,199.5 335.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 169.5,192.5 C 175.5,192.5 181.5,192.5 187.5,192.5C 188.833,192.5 190.167,192.5 191.5,192.5C 190.934,199.451 191.601,206.118 193.5,212.5C 188.587,214.007 183.421,214.674 178,214.5C 174.317,214.499 170.817,214.165 167.5,213.5C 167.082,212.778 166.416,212.278 165.5,212C 166.8,205.366 168.133,198.866 169.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#151515",
    d: "M 123.5,203.5 C 124.833,203.5 126.167,203.5 127.5,203.5C 133.842,203.334 140.175,203.5 146.5,204C 152.5,209.333 159.5,212.499 167.5,213.5C 170.817,214.165 174.317,214.499 178,214.5C 183.421,214.674 188.587,214.007 193.5,212.5C 196.89,211.977 200.223,211.143 203.5,210C 206.328,207.752 209.328,205.752 212.5,204C 218.825,203.5 225.158,203.334 231.5,203.5C 232.5,203.5 233.5,203.5 234.5,203.5C 243.869,205.418 253.202,208.085 262.5,211.5C 277.841,217.818 290.507,227.485 300.5,240.5C 304.464,246.775 308.131,253.108 311.5,259.5C 311.232,261.099 311.566,262.432 312.5,263.5C 314.715,279.787 315.049,296.121 313.5,312.5C 268.833,312.833 224.167,313.167 179.5,313.5C 134.289,313.495 89.2891,312.828 44.5,311.5C 44.5,303.5 44.5,295.5 44.5,287.5C 44.1318,279.713 44.7985,272.046 46.5,264.5C 47.2341,263.292 47.5674,261.959 47.5,260.5C 55.4517,241.873 68.1184,227.207 85.5,216.5C 88.8721,214.814 92.2054,213.147 95.5,211.5C 104.644,207.78 113.978,205.114 123.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,215.5 C 7.5,215.5 15.5,215.5 23.5,215.5C 23.5,223.5 23.5,231.5 23.5,239.5C 15.5,239.5 7.5,239.5 -0.5,239.5C -0.5,231.5 -0.5,223.5 -0.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2f2",
    d: "M 47.5,191.5 C 55.5,191.5 63.5,191.5 71.5,191.5C 71.5,199.5 71.5,207.5 71.5,215.5C 76.2303,215.283 80.8969,215.617 85.5,216.5C 68.1184,227.207 55.4517,241.873 47.5,260.5C 47.5,253.5 47.5,246.5 47.5,239.5C 39.5,239.5 31.5,239.5 23.5,239.5C 23.5,231.5 23.5,223.5 23.5,215.5C 31.5,215.5 39.5,215.5 47.5,215.5C 47.5,207.5 47.5,199.5 47.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 103.5,215.5 C 108.833,215.5 114.167,215.5 119.5,215.5C 119.5,223.5 119.5,231.5 119.5,239.5C 111.5,239.5 103.5,239.5 95.5,239.5C 95.5,232.5 95.5,225.5 95.5,218.5C 97.6845,216.415 100.351,215.415 103.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 153.5,215.5 C 150.167,215.5 146.833,215.5 143.5,215.5C 143.5,223.5 143.5,231.5 143.5,239.5C 135.5,239.5 127.5,239.5 119.5,239.5C 119.5,231.5 119.5,223.5 119.5,215.5C 114.167,215.5 108.833,215.5 103.5,215.5C 103.611,214.883 103.944,214.383 104.5,214C 117.153,209.627 130.153,207.96 143.5,209C 146.728,211.44 150.061,213.606 153.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 153.5,215.5 C 158.167,216.834 162.834,218.167 167.5,219.5C 167.918,220.222 168.584,220.722 169.5,221C 167.57,226.874 166.903,233.04 167.5,239.5C 159.5,239.5 151.5,239.5 143.5,239.5C 143.5,231.5 143.5,223.5 143.5,215.5C 146.833,215.5 150.167,215.5 153.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 204.5,215.5 C 208.167,215.5 211.833,215.5 215.5,215.5C 215.5,223.5 215.5,231.5 215.5,239.5C 207.5,239.5 199.5,239.5 191.5,239.5C 191.5,232.833 191.5,226.167 191.5,219.5C 195.687,218.031 200.02,216.698 204.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 249.5,213.5 C 246.416,215.101 243.083,215.768 239.5,215.5C 239.5,223.5 239.5,231.5 239.5,239.5C 231.5,239.5 223.5,239.5 215.5,239.5C 215.5,231.5 215.5,223.5 215.5,215.5C 211.833,215.5 208.167,215.5 204.5,215.5C 208.071,213.373 211.738,211.206 215.5,209C 224.934,208.173 234.267,208.84 243.5,211C 245.852,211.24 247.852,212.073 249.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 249.5,213.5 C 255.077,214.352 260.077,216.352 264.5,219.5C 263.642,225.805 263.308,232.471 263.5,239.5C 255.5,239.5 247.5,239.5 239.5,239.5C 239.5,231.5 239.5,223.5 239.5,215.5C 243.083,215.768 246.416,215.101 249.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 263.5,191.5 C 271.5,191.5 279.5,191.5 287.5,191.5C 287.5,199.5 287.5,207.5 287.5,215.5C 295.5,215.5 303.5,215.5 311.5,215.5C 311.5,223.5 311.5,231.5 311.5,239.5C 307.766,239.323 304.099,239.656 300.5,240.5C 290.507,227.485 277.841,217.818 262.5,211.5C 262.577,210.25 263.244,209.417 264.5,209C 263.525,203.259 263.192,197.425 263.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 311.5,215.5 C 319.5,215.5 327.5,215.5 335.5,215.5C 335.5,223.5 335.5,231.5 335.5,239.5C 327.5,239.5 319.5,239.5 311.5,239.5C 311.5,231.5 311.5,223.5 311.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,215.5 C 343.5,215.5 351.5,215.5 359.5,215.5C 359.5,223.5 359.5,231.5 359.5,239.5C 351.5,239.5 343.5,239.5 335.5,239.5C 335.5,231.5 335.5,223.5 335.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebebeb",
    d: "M 167.5,219.5 C 175.488,220.751 183.488,220.751 191.5,219.5C 191.5,226.167 191.5,232.833 191.5,239.5C 183.5,239.5 175.5,239.5 167.5,239.5C 166.903,233.04 167.57,226.874 169.5,221C 168.584,220.722 167.918,220.222 167.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaea",
    d: "M 95.5,218.5 C 95.5,225.5 95.5,232.5 95.5,239.5C 87.5,239.5 79.5,239.5 71.5,239.5C 71.5,247.5 71.5,255.5 71.5,263.5C 65.5,263.5 59.5,263.5 53.5,263.5C 55.4018,255.696 58.9018,248.696 64,242.5C 72.673,231.934 83.173,223.934 95.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,239.5 C 7.5,239.5 15.5,239.5 23.5,239.5C 23.5,247.5 23.5,255.5 23.5,263.5C 15.5,263.5 7.5,263.5 -0.5,263.5C -0.5,255.5 -0.5,247.5 -0.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 23.5,239.5 C 31.5,239.5 39.5,239.5 47.5,239.5C 47.5,246.5 47.5,253.5 47.5,260.5C 47.5674,261.959 47.2341,263.292 46.5,264.5C 38.9196,263.534 31.253,263.201 23.5,263.5C 23.5,255.5 23.5,247.5 23.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 95.5,239.5 C 95.5,247.5 95.5,255.5 95.5,263.5C 87.5,263.5 79.5,263.5 71.5,263.5C 71.5,255.5 71.5,247.5 71.5,239.5C 79.5,239.5 87.5,239.5 95.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 95.5,239.5 C 103.5,239.5 111.5,239.5 119.5,239.5C 119.5,247.5 119.5,255.5 119.5,263.5C 111.5,263.5 103.5,263.5 95.5,263.5C 95.5,255.5 95.5,247.5 95.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,239.5 C 127.5,239.5 135.5,239.5 143.5,239.5C 143.5,247.5 143.5,255.5 143.5,263.5C 135.5,263.5 127.5,263.5 119.5,263.5C 119.5,255.5 119.5,247.5 119.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 143.5,239.5 C 151.5,239.5 159.5,239.5 167.5,239.5C 167.5,247.5 167.5,255.5 167.5,263.5C 159.5,263.5 151.5,263.5 143.5,263.5C 143.5,255.5 143.5,247.5 143.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,239.5 C 175.5,239.5 183.5,239.5 191.5,239.5C 191.5,247.5 191.5,255.5 191.5,263.5C 183.5,263.5 175.5,263.5 167.5,263.5C 167.5,255.5 167.5,247.5 167.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 191.5,239.5 C 199.5,239.5 207.5,239.5 215.5,239.5C 215.5,247.5 215.5,255.5 215.5,263.5C 207.5,263.5 199.5,263.5 191.5,263.5C 191.5,255.5 191.5,247.5 191.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 215.5,239.5 C 223.5,239.5 231.5,239.5 239.5,239.5C 239.5,247.5 239.5,255.5 239.5,263.5C 231.5,263.5 223.5,263.5 215.5,263.5C 215.5,255.5 215.5,247.5 215.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 239.5,239.5 C 247.5,239.5 255.5,239.5 263.5,239.5C 263.5,247.5 263.5,255.5 263.5,263.5C 255.5,263.5 247.5,263.5 239.5,263.5C 239.5,255.5 239.5,247.5 239.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,239.5 C 271.5,239.5 279.5,239.5 287.5,239.5C 287.5,247.5 287.5,255.5 287.5,263.5C 279.5,263.5 271.5,263.5 263.5,263.5C 263.5,255.5 263.5,247.5 263.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e8e8",
    d: "M 264.5,219.5 C 286.999,228.666 301.332,244.999 307.5,268.5C 306.661,267.359 305.994,266.026 305.5,264.5C 299.537,263.504 293.537,263.171 287.5,263.5C 287.5,255.5 287.5,247.5 287.5,239.5C 279.5,239.5 271.5,239.5 263.5,239.5C 263.308,232.471 263.642,225.805 264.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e5e5",
    d: "M 311.5,239.5 C 311.5,246.167 311.5,252.833 311.5,259.5C 308.131,253.108 304.464,246.775 300.5,240.5C 304.099,239.656 307.766,239.323 311.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 311.5,239.5 C 319.5,239.5 327.5,239.5 335.5,239.5C 335.5,247.5 335.5,255.5 335.5,263.5C 328.711,262.899 322.211,263.566 316,265.5C 315.667,264.833 315.333,264.167 315,263.5C 314.23,264.598 313.397,264.598 312.5,263.5C 311.566,262.432 311.232,261.099 311.5,259.5C 311.5,252.833 311.5,246.167 311.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,239.5 C 343.5,239.5 351.5,239.5 359.5,239.5C 359.5,247.5 359.5,255.5 359.5,263.5C 351.5,263.5 343.5,263.5 335.5,263.5C 335.5,255.5 335.5,247.5 335.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,263.5 C 7.5,263.5 15.5,263.5 23.5,263.5C 23.5,271.5 23.5,279.5 23.5,287.5C 15.5,287.5 7.5,287.5 -0.5,287.5C -0.5,279.5 -0.5,271.5 -0.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 23.5,263.5 C 31.253,263.201 38.9196,263.534 46.5,264.5C 44.7985,272.046 44.1318,279.713 44.5,287.5C 37.5,287.5 30.5,287.5 23.5,287.5C 23.5,279.5 23.5,271.5 23.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 53.5,263.5 C 59.5,263.5 65.5,263.5 71.5,263.5C 71.5,271.5 71.5,279.5 71.5,287.5C 64.8333,287.5 58.1667,287.5 51.5,287.5C 51.5,282.167 51.5,276.833 51.5,271.5C 51.1107,268.447 51.7773,265.78 53.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 71.5,263.5 C 79.5,263.5 87.5,263.5 95.5,263.5C 95.5,271.5 95.5,279.5 95.5,287.5C 87.5,287.5 79.5,287.5 71.5,287.5C 71.5,279.5 71.5,271.5 71.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 95.5,263.5 C 103.5,263.5 111.5,263.5 119.5,263.5C 119.5,271.5 119.5,279.5 119.5,287.5C 111.5,287.5 103.5,287.5 95.5,287.5C 95.5,279.5 95.5,271.5 95.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 119.5,263.5 C 127.5,263.5 135.5,263.5 143.5,263.5C 143.5,271.5 143.5,279.5 143.5,287.5C 135.5,287.5 127.5,287.5 119.5,287.5C 119.5,279.5 119.5,271.5 119.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 143.5,263.5 C 151.5,263.5 159.5,263.5 167.5,263.5C 167.5,271.5 167.5,279.5 167.5,287.5C 159.5,287.5 151.5,287.5 143.5,287.5C 143.5,279.5 143.5,271.5 143.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 167.5,263.5 C 175.5,263.5 183.5,263.5 191.5,263.5C 191.5,271.5 191.5,279.5 191.5,287.5C 183.5,287.5 175.5,287.5 167.5,287.5C 167.5,279.5 167.5,271.5 167.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 191.5,263.5 C 199.5,263.5 207.5,263.5 215.5,263.5C 215.5,271.5 215.5,279.5 215.5,287.5C 207.5,287.5 199.5,287.5 191.5,287.5C 191.5,279.5 191.5,271.5 191.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 215.5,263.5 C 223.5,263.5 231.5,263.5 239.5,263.5C 239.5,271.5 239.5,279.5 239.5,287.5C 231.5,287.5 223.5,287.5 215.5,287.5C 215.5,279.5 215.5,271.5 215.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 239.5,263.5 C 247.5,263.5 255.5,263.5 263.5,263.5C 263.5,271.5 263.5,279.5 263.5,287.5C 255.5,287.5 247.5,287.5 239.5,287.5C 239.5,279.5 239.5,271.5 239.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 263.5,263.5 C 271.5,263.5 279.5,263.5 287.5,263.5C 287.5,271.5 287.5,279.5 287.5,287.5C 279.5,287.5 271.5,287.5 263.5,287.5C 263.5,279.5 263.5,271.5 263.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 287.5,263.5 C 293.537,263.171 299.537,263.504 305.5,264.5C 305.994,266.026 306.661,267.359 307.5,268.5C 308.458,274.744 308.791,281.077 308.5,287.5C 301.5,287.5 294.5,287.5 287.5,287.5C 287.5,279.5 287.5,271.5 287.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,263.5 C 343.5,263.5 351.5,263.5 359.5,263.5C 359.5,271.5 359.5,279.5 359.5,287.5C 351.5,287.5 343.5,287.5 335.5,287.5C 335.5,279.5 335.5,271.5 335.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,287.5 C 7.5,287.5 15.5,287.5 23.5,287.5C 23.5,295.5 23.5,303.5 23.5,311.5C 15.5,311.5 7.5,311.5 -0.5,311.5C -0.5,303.5 -0.5,295.5 -0.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 23.5,287.5 C 30.5,287.5 37.5,287.5 44.5,287.5C 44.5,295.5 44.5,303.5 44.5,311.5C 37.5,311.5 30.5,311.5 23.5,311.5C 23.5,303.5 23.5,295.5 23.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 51.5,271.5 C 51.5,276.833 51.5,282.167 51.5,287.5C 58.1667,287.5 64.8333,287.5 71.5,287.5C 71.5,294.167 71.5,300.833 71.5,307.5C 64.5,307.5 57.5,307.5 50.5,307.5C 50.1716,295.322 50.5049,283.322 51.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 71.5,287.5 C 79.5,287.5 87.5,287.5 95.5,287.5C 95.5,294.167 95.5,300.833 95.5,307.5C 87.5,307.5 79.5,307.5 71.5,307.5C 71.5,300.833 71.5,294.167 71.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 95.5,287.5 C 103.5,287.5 111.5,287.5 119.5,287.5C 119.5,294.167 119.5,300.833 119.5,307.5C 111.5,307.5 103.5,307.5 95.5,307.5C 95.5,300.833 95.5,294.167 95.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 119.5,287.5 C 127.5,287.5 135.5,287.5 143.5,287.5C 143.5,294.167 143.5,300.833 143.5,307.5C 135.5,307.5 127.5,307.5 119.5,307.5C 119.5,300.833 119.5,294.167 119.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 143.5,287.5 C 151.5,287.5 159.5,287.5 167.5,287.5C 167.5,294.167 167.5,300.833 167.5,307.5C 159.5,307.5 151.5,307.5 143.5,307.5C 143.5,300.833 143.5,294.167 143.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 167.5,287.5 C 175.5,287.5 183.5,287.5 191.5,287.5C 191.5,294.167 191.5,300.833 191.5,307.5C 183.5,307.5 175.5,307.5 167.5,307.5C 167.5,300.833 167.5,294.167 167.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 191.5,287.5 C 199.5,287.5 207.5,287.5 215.5,287.5C 215.5,294.167 215.5,300.833 215.5,307.5C 207.5,307.5 199.5,307.5 191.5,307.5C 191.5,300.833 191.5,294.167 191.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 215.5,287.5 C 223.5,287.5 231.5,287.5 239.5,287.5C 239.5,294.167 239.5,300.833 239.5,307.5C 231.5,307.5 223.5,307.5 215.5,307.5C 215.5,300.833 215.5,294.167 215.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 239.5,287.5 C 247.5,287.5 255.5,287.5 263.5,287.5C 263.5,294.167 263.5,300.833 263.5,307.5C 255.5,307.5 247.5,307.5 239.5,307.5C 239.5,300.833 239.5,294.167 239.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 263.5,287.5 C 271.5,287.5 279.5,287.5 287.5,287.5C 287.5,294.167 287.5,300.833 287.5,307.5C 279.5,307.5 271.5,307.5 263.5,307.5C 263.5,300.833 263.5,294.167 263.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 287.5,287.5 C 294.5,287.5 301.5,287.5 308.5,287.5C 308.5,294.167 308.5,300.833 308.5,307.5C 301.5,307.5 294.5,307.5 287.5,307.5C 287.5,300.833 287.5,294.167 287.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 335.5,287.5 C 335.5,295.5 335.5,303.5 335.5,311.5C 328.833,311.5 322.167,311.5 315.5,311.5C 315.5,303.5 315.5,295.5 315.5,287.5C 322.167,287.5 328.833,287.5 335.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,287.5 C 343.5,287.5 351.5,287.5 359.5,287.5C 359.5,295.5 359.5,303.5 359.5,311.5C 351.5,311.5 343.5,311.5 335.5,311.5C 335.5,303.5 335.5,295.5 335.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,311.5 C 7.5,311.5 15.5,311.5 23.5,311.5C 23.5,319.5 23.5,327.5 23.5,335.5C 15.5,335.5 7.5,335.5 -0.5,335.5C -0.5,327.5 -0.5,319.5 -0.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ececec",
    d: "M 312.5,263.5 C 313.397,264.598 314.23,264.598 315,263.5C 315.333,264.167 315.667,264.833 316,265.5C 322.211,263.566 328.711,262.899 335.5,263.5C 335.5,271.5 335.5,279.5 335.5,287.5C 328.833,287.5 322.167,287.5 315.5,287.5C 315.5,295.5 315.5,303.5 315.5,311.5C 322.167,311.5 328.833,311.5 335.5,311.5C 335.5,319.5 335.5,327.5 335.5,335.5C 327.5,335.5 319.5,335.5 311.5,335.5C 311.5,328.5 311.5,321.5 311.5,314.5C 303.5,314.5 295.5,314.5 287.5,314.5C 287.5,321.5 287.5,328.5 287.5,335.5C 279.5,335.5 271.5,335.5 263.5,335.5C 263.5,328.5 263.5,321.5 263.5,314.5C 255.5,314.5 247.5,314.5 239.5,314.5C 239.5,321.5 239.5,328.5 239.5,335.5C 231.5,335.5 223.5,335.5 215.5,335.5C 215.5,328.5 215.5,321.5 215.5,314.5C 207.5,314.5 199.5,314.5 191.5,314.5C 191.5,321.5 191.5,328.5 191.5,335.5C 183.5,335.5 175.5,335.5 167.5,335.5C 167.5,328.5 167.5,321.5 167.5,314.5C 159.5,314.5 151.5,314.5 143.5,314.5C 143.5,321.5 143.5,328.5 143.5,335.5C 135.5,335.5 127.5,335.5 119.5,335.5C 119.5,328.5 119.5,321.5 119.5,314.5C 111.5,314.5 103.5,314.5 95.5,314.5C 95.5,321.5 95.5,328.5 95.5,335.5C 87.5,335.5 79.5,335.5 71.5,335.5C 71.5,328.5 71.5,321.5 71.5,314.5C 63.5,314.5 55.5,314.5 47.5,314.5C 47.5,321.5 47.5,328.5 47.5,335.5C 39.5,335.5 31.5,335.5 23.5,335.5C 23.5,327.5 23.5,319.5 23.5,311.5C 30.5,311.5 37.5,311.5 44.5,311.5C 89.2891,312.828 134.289,313.495 179.5,313.5C 224.167,313.167 268.833,312.833 313.5,312.5C 315.049,296.121 314.715,279.787 312.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 335.5,311.5 C 343.5,311.5 351.5,311.5 359.5,311.5C 359.5,319.5 359.5,327.5 359.5,335.5C 351.5,335.5 343.5,335.5 335.5,335.5C 335.5,327.5 335.5,319.5 335.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 71.5,335.5 C 63.5,335.5 55.5,335.5 47.5,335.5C 47.5,328.5 47.5,321.5 47.5,314.5C 55.5,314.5 63.5,314.5 71.5,314.5C 71.5,321.5 71.5,328.5 71.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 119.5,335.5 C 111.5,335.5 103.5,335.5 95.5,335.5C 95.5,328.5 95.5,321.5 95.5,314.5C 103.5,314.5 111.5,314.5 119.5,314.5C 119.5,321.5 119.5,328.5 119.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 167.5,335.5 C 159.5,335.5 151.5,335.5 143.5,335.5C 143.5,328.5 143.5,321.5 143.5,314.5C 151.5,314.5 159.5,314.5 167.5,314.5C 167.5,321.5 167.5,328.5 167.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 215.5,335.5 C 207.5,335.5 199.5,335.5 191.5,335.5C 191.5,328.5 191.5,321.5 191.5,314.5C 199.5,314.5 207.5,314.5 215.5,314.5C 215.5,321.5 215.5,328.5 215.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 263.5,335.5 C 255.5,335.5 247.5,335.5 239.5,335.5C 239.5,328.5 239.5,321.5 239.5,314.5C 247.5,314.5 255.5,314.5 263.5,314.5C 263.5,321.5 263.5,328.5 263.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 311.5,335.5 C 303.5,335.5 295.5,335.5 287.5,335.5C 287.5,328.5 287.5,321.5 287.5,314.5C 295.5,314.5 303.5,314.5 311.5,314.5C 311.5,321.5 311.5,328.5 311.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M -0.5,335.5 C 7.5,335.5 15.5,335.5 23.5,335.5C 23.5,343.5 23.5,351.5 23.5,359.5C 15.5,359.5 7.5,359.5 -0.5,359.5C -0.5,351.5 -0.5,343.5 -0.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 23.5,335.5 C 31.5,335.5 39.5,335.5 47.5,335.5C 47.5,343.5 47.5,351.5 47.5,359.5C 39.5,359.5 31.5,359.5 23.5,359.5C 23.5,351.5 23.5,343.5 23.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 47.5,335.5 C 55.5,335.5 63.5,335.5 71.5,335.5C 71.5,343.5 71.5,351.5 71.5,359.5C 63.5,359.5 55.5,359.5 47.5,359.5C 47.5,351.5 47.5,343.5 47.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 71.5,335.5 C 79.5,335.5 87.5,335.5 95.5,335.5C 95.5,343.5 95.5,351.5 95.5,359.5C 87.5,359.5 79.5,359.5 71.5,359.5C 71.5,351.5 71.5,343.5 71.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 95.5,335.5 C 103.5,335.5 111.5,335.5 119.5,335.5C 119.5,343.5 119.5,351.5 119.5,359.5C 111.5,359.5 103.5,359.5 95.5,359.5C 95.5,351.5 95.5,343.5 95.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,335.5 C 127.5,335.5 135.5,335.5 143.5,335.5C 143.5,343.5 143.5,351.5 143.5,359.5C 135.5,359.5 127.5,359.5 119.5,359.5C 119.5,351.5 119.5,343.5 119.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 143.5,335.5 C 151.5,335.5 159.5,335.5 167.5,335.5C 167.5,343.5 167.5,351.5 167.5,359.5C 159.5,359.5 151.5,359.5 143.5,359.5C 143.5,351.5 143.5,343.5 143.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 167.5,335.5 C 175.5,335.5 183.5,335.5 191.5,335.5C 191.5,343.5 191.5,351.5 191.5,359.5C 183.5,359.5 175.5,359.5 167.5,359.5C 167.5,351.5 167.5,343.5 167.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 191.5,335.5 C 199.5,335.5 207.5,335.5 215.5,335.5C 215.5,343.5 215.5,351.5 215.5,359.5C 207.5,359.5 199.5,359.5 191.5,359.5C 191.5,351.5 191.5,343.5 191.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 215.5,335.5 C 223.5,335.5 231.5,335.5 239.5,335.5C 239.5,343.5 239.5,351.5 239.5,359.5C 231.5,359.5 223.5,359.5 215.5,359.5C 215.5,351.5 215.5,343.5 215.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 239.5,335.5 C 247.5,335.5 255.5,335.5 263.5,335.5C 263.5,343.5 263.5,351.5 263.5,359.5C 255.5,359.5 247.5,359.5 239.5,359.5C 239.5,351.5 239.5,343.5 239.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 263.5,335.5 C 271.5,335.5 279.5,335.5 287.5,335.5C 287.5,343.5 287.5,351.5 287.5,359.5C 279.5,359.5 271.5,359.5 263.5,359.5C 263.5,351.5 263.5,343.5 263.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 287.5,335.5 C 295.5,335.5 303.5,335.5 311.5,335.5C 311.5,343.5 311.5,351.5 311.5,359.5C 303.5,359.5 295.5,359.5 287.5,359.5C 287.5,351.5 287.5,343.5 287.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 311.5,335.5 C 319.5,335.5 327.5,335.5 335.5,335.5C 335.5,343.5 335.5,351.5 335.5,359.5C 327.5,359.5 319.5,359.5 311.5,359.5C 311.5,351.5 311.5,343.5 311.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeeed",
    d: "M 335.5,335.5 C 343.5,335.5 351.5,335.5 359.5,335.5C 359.5,343.5 359.5,351.5 359.5,359.5C 351.5,359.5 343.5,359.5 335.5,359.5C 335.5,351.5 335.5,343.5 335.5,335.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdm);
export default __webpack_public_path__ + "static/media/kdm.a302360f225ae925d6dec3b8d28c520c.svg";
export { ForwardRef as ReactComponent };